// Estilo
import estilo from './pageAboutUs.module.css';

// Componentes
import Background from "../../elements/backgrounds/background";

// Data
import { TEXT } from "../../../utils/varGlobal";
import LabelMenu from '../../elements/labels/labelMenu';

function PageAboutUs(){

    return (
        <main>
            <Background verImagen={false}>
                <LabelMenu opcion='about' goBack={true}/>
                <p id={estilo.text}>
                    {TEXT.about_us.TEXT.join("\n\n")}
                </p>
            </Background>
        </main>
    )
}

export default PageAboutUs;